export default "__VITE_ASSET__Dzk2Ufyq__"